import Vue from 'vue'
import Router from 'vue-router'
import Index from '@/components/Index'
import Error from '@/components/Error'
import ErrorContent from '@/components/ErrorContent'
import Dashboard from '@/components/Dashboard'
import DashboardCardio from '@/components/DashboardCardio'
import Todo from '@/components/Todo'
import TodoCardio from '@/components/TodoCardio'
import TodoGenNegative from '@/components/TodoGenNegative'
import LandingPage from '@/components/LandingPage'
import Admin from '@/components/Admin'
import AllPatients from '@/components/AllPatients'
import AllPatientsGenNegative from '@/components/AllPatientsGenNegative'
import AllPatientsCardio from '@/components/AllPatientsCardio'
import IndexPatients from '@/components/IndexPatients'
import IndexPatient from '@/components/IndexPatient'
import IndexPatientGenNegative from '@/components/IndexPatientGenNegative'
import CreateNewIdx from '@/components/CreateNewIdx'
import CreateNewMinor from '@/components/CreateNewMinor'
import CreateNewCardio from '@/components/CreateNewCardio'
import EditCardioPatient from '@/components/EditCardioPatient'
import EditIdxPatient from '@/components/EditIdxPatient'
import Patient from '@/components/Patient'
import PatientGenNegative from '@/components/PatientGenNegative'
import PatientCardio from '@/components/PatientCardio'
import Faq from '@/components/Faq'
import Statistics from '@/components/Statistics'
import { handleSessionIdQueryParam } from '../plugins/queryparam'

Vue.use(Router)

const router = new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'index',
      component: Index,
      meta: {
        showData: false,
        showSearch: false
      }
    },
    {
      path: '*', // all other paths,
      name: 'error', // goes to this,
      component: Error, // since most components are routed,
      meta: {}, // and neccessary for the application.
      props: true
    },
    {
      path: '/errorcontent',
      name: 'errorcontent',
      component: ErrorContent,
      props: true
    },
    {
      path: '/dashboard',
      name: 'dashboard',
      component: Dashboard,
      meta: {
        reqClinicPrivileges: true,
        showData: true,
        showSearch: false
      }
    },
    {
      path: '/dashboardcardio',
      name: 'dashboardcardio',
      component: DashboardCardio,
      meta: {
        reqClinicPrivileges: true,
        showData: true,
        showSearch: false
      }
    },
    {
      path: '/todo',
      name: 'todo',
      component: Todo,
      meta: {
        reqClinicPrivileges: true,
        showData: true,
        showSearch: false
      }
    },
    {
      path: '/todo_gen_negative',
      name: 'todo_gen_negative',
      component: TodoGenNegative,
      meta: {
        reqClinicPrivileges: true,
        showData: true,
        showSearch: false
      }
    },
    {
      path: '/todocardio',
      name: 'todocardio',
      component: TodoCardio,
      meta: {
        reqClinicPrivileges: true,
        showData: true,
        showSearch: false
      }
    },
    {
      path: '/landingpage',
      name: 'landingpage',
      component: LandingPage,
      meta: {
        reqClinicPrivileges: true,
        showData: true,
        showSearch: false,
        resetType: true
      }
    },
    {
      path: '/adm',
      name: 'admin',
      component: Admin,
      meta: {
        reqClinicPrivileges: true,
        showData: true,
        showSearch: false
      }
    },
    {
      path: '/patients',
      name: 'allpatients',
      component: AllPatients,
      meta: {
        reqClinicPrivileges: true,
        showData: true,
        showSearch: false
      }
    },
    {
      path: '/patients_gen_negative',
      name: 'allpatients_gen_negative',
      component: AllPatientsGenNegative,
      meta: {
        reqClinicPrivileges: true,
        showData: true,
        showSearch: false
      }
    },
    {
      path: '/patientscardio',
      name: 'allpatientscardio',
      component: AllPatientsCardio,
      meta: {
        reqClinicPrivileges: true,
        showData: true,
        showSearch: false
      }
    },
    {
      path: '/indexpatients',
      name: 'indexpatients',
      component: IndexPatients,
      meta: {
        reqClinicPrivileges: true,
        showData: true,
        showSearch: false
      }
    },
    {
      path: '/faq',
      name: 'faq',
      component: Faq,
      meta: {
        reqClinicPrivileges: false,
        showData: false,
        showSearch: false
      }
    },
    {
      path: '/stats',
      alias: ['/statscardio', '/stats_gen_negative'],
      name: 'statistics',
      component: Statistics,
      meta: {
        reqClinicPrivileges: true,
        showData: true,
        showSearch: false
      }
    },
    {
      path: '/indexpatient/:id(\\d+)',
      name: 'indexpatient',
      component: IndexPatient,
      meta: {
        reqClinicPrivileges: true,
        showData: true,
        showSearch: false
      },
      props: true
    },
    {
      path: '/indexpatient_gen_negative/:id(\\d+)',
      name: 'indexpatient_gen_negative',
      component: IndexPatientGenNegative,
      meta: {
        reqClinicPrivileges: true,
        showData: true,
        showSearch: false
      },
      props: true
    },
    {
      path: '/patient/:id(\\d+)',
      name: 'patient',
      component: Patient,
      meta: {
        reqClinicPrivileges: true,
        showData: true,
        showSearch: false
      },
      props: true
    },
    {
      path: '/patient_gen_negative/:id(\\d+)',
      name: 'patient_gen_negative',
      component: PatientGenNegative,
      meta: {
        reqClinicPrivileges: true,
        showData: true,
        showSearch: false
      },
      props: true
    },
    {
      path: '/patientcardio/:id(\\d+)',
      name: 'patientcardio',
      component: PatientCardio,
      meta: {
        reqClinicPrivileges: true,
        showData: true,
        showSearch: false
      },
      props: true
    },
    {
      path: '/editcardio/:id(\\d+)',
      name: 'editcardiopatient',
      component: EditCardioPatient,
      meta: {
        reqClinicPrivileges: true,
        showData: true,
        showSearch: false
      },
      props: true
    },
    {
      path: '/editidx/:id(\\d+)',
      name: 'editidxpatient',
      component: EditIdxPatient,
      meta: {
        reqClinicPrivileges: true,
        showData: true,
        showSearch: false
      },
      props: true
    },
    {
      path: '/newidx',
      name: 'createnewidx',
      component: CreateNewIdx,
      meta: {
        reqClinicPrivileges: true,
        showData: true,
        showSearch: false
      },
      props: true
    },
    {
      path: '/newminor',
      name: 'createnewminor',
      component: CreateNewMinor,
      meta: {
        reqClinicPrivileges: true,
        showData: true,
        showSearch: false
      },
      props: true
    },
    {
      path: '/newcardio',
      name: 'createnewcardio',
      component: CreateNewCardio,
      meta: {
        reqClinicPrivileges: true,
        showData: true,
        showSearch: false
      },
      props: true
    }
  ],
  scrollBehavior () {
    window.scrollTo(0, 0)
  }
})

/* Route Guard */
router.beforeEach((to, from, next) => {
  handleSessionIdQueryParam()
  if (to.matched.some(route => route.meta.reqClinicPrivileges)) {
    if (localStorage.getItem('isClinician')) {
      next()
    } else {
      next({
        path: '/'
      })
    }
  }
  if (to.matched.some(route => route.meta.resetType)) {
    localStorage.removeItem('patientType')
  }
  next()
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js